<template>
    <div v-loading="!finishGetList">
        <board-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter" :categoryData="categoryData"
                           :sortData="filterSet.sort" :paginationData="filterSet.page"></board-filter-link>
        <board-list-link :listLayout="listLayout" :boardData="List" :categoryData="categoryData"
                                :paginationData="filterSet.page"></board-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"></pagination-link>
    </div>
</template>

<script>
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import boardFilterUtil from "@/components/board/boardFilterUtil";
import boardTemplateUtil from "@/components/board/boardTemplateUtil";
import PaginationLink from "@/components/board/PaginationLink";
import BoardListLink from "@/components/board/BoardListLink";
import util from "@/mixins/util";
import BoardFilterLink from "@/components/board/BoardFilterLink";
import DeleteClass from "@/mixins/deleteClass";
import EventBus from "@/mixins/event-bus";
import alertMixins from "@/mixins/alertMixins";

const {filterConfig} = boardFilterUtil;
export default {
    name: "BoardListComponent",
    mixins: [alertMixins, filterMixins, listMixins, boardFilterUtil, boardTemplateUtil],
    components: {BoardFilterLink, BoardListLink, PaginationLink},
    inject: [],
    provide() {
        return {
            setPage: this.setPage,
            setFilter: this.setFilter,
            setFilterNotParser: this.setFilterNotParser,
            setSort: this.setSort,
            setSortNotParser: this.setSortNotParser,
            boardListDelete: this.runDeleteConfirm,
        }
    },
    props: {
        boardType: '',
        defaultFilter: {
            default: () => {
            }
        },
    },
    data() {
        return {
            filterLayout: '',
            listLayout: '',
            paginationLayout: '',

            listApiParamSet: {},
            getFunc: '',
            pageRow: '',
            categoryData: [],
            isCategory: false,
            getCategoryFunc: '',

            keyName: '',
            directUrl: '',
            directType: '',

            deleteFunc: '',
            deleteApiParamsSet: {},
            deleteSuccessType: 1,
            deleteFailTypes: {},
            deleteKeyName: '',

            DeleteClass: null,
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initConfig();
        this.setFilterConfig(filterConfig)
        this.setParserType('url', this.$route.fullPath);
    },
    mounted() {
        if (this.isGetFirst) {
            this.getList(true);
        } else {
            this.finishGetList = true;
        }
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },

        initConfig() {
            let boardTemplateConfig = this.returnBoardTemplateConfig(this.boardType);
            this.filterLayout = boardTemplateConfig.filterLayout;
            this.listLayout = boardTemplateConfig.listLayout;
            this.paginationLayout = boardTemplateConfig.paginationLayout;

            let config = this.returnBoardFilterConfig(this.boardType);
            this.listApiParamSet = config.listApiParamSet;
            this.getFunc = config.getFunc;
            this.pageRow = config.pageRow;
            this.isCategory = config.isCategory;
            this.getCategoryFunc = config.getCategoryFunc;

            this.keyName = config.keyName
            this.directUrl = config.directUrl;
            this.directType = config.directType;

            this.deleteFunc = config.deleteFunc;
            this.deleteApiParamsSet = config.deleteApiParamsSet;
            this.deleteSuccessType = config.deleteSuccessType;
            this.deleteFailTypes = config.deleteFailTypes;

            this.newDeleteClass();

            let defaultParams = Object.assign({}, this.listApiParamSet, this.defaultFilter);
            let listOptions = {
                url: this.$api.$board[this.getFunc],
                defaultParams: defaultParams,
            }

            this.initList('api', listOptions);

            if (this.isCategory) {
                this.getCategory();
            }
        },

        getCategory() {
            let params = {};
            try {
                this.$api.$board[this.getCategoryFunc](params).then(res => res.Data.Result).then(res => {
                    if (!util.isEmpty(res.List)) {
                        this.categoryData = res.List;
                    }
                })
            } catch (e) {
                console.log(e);
            }
        },

        newDeleteClass() {
            if (!util.isEmpty(this.deleteFunc)) {
                let deleteOptions = {
                    func: this.$api.$board[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.keyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                }
                this.DeleteClass = new DeleteClass(deleteOptions);
            }
        },

        runDeleteConfirm(key) {
            this.createConfirm({
                content: '삭제하시겠습니까?',
                confirm: () => {
                    this.runDelete(key);
                }
            })
        },

        runDelete(key) {
            EventBus.$emit('apiLoading', true);
            this.DeleteClass.runDelete(key)
        },

        deleteAfterFunc() {
            EventBus.$emit('changeLoading', false)
            this.createAlert({
                content: '삭제가 완료되었습니다.',
                hide: () => {
                    this.getList();
                }
            })
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
